<template>
  <div class="jurisdiction-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      @click="$emit('cancel')"
    >
      {{ $t('buttons.cancel') }}
    </button>
    <button
      v-if="mode === 'create'"
      :class="{
        disabled: !jurisdictionForm.displayName || !jurisdictionForm.codename
      }"
      type="button"
      class="btn btn-primary"
      @click="$emit('save-continue')"
    >
      {{ $t('buttons.saveContinue') }}
    </button>
    <button
      :class="{
        disabled: !jurisdictionForm.displayName || !jurisdictionForm.codename
      }"
      type="button"
      class="btn btn-primary"
      @click="$emit('save')"
    >
      {{ $t('buttons.save') }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'JuridictionFooter',

  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },

  computed: {
    ...mapState('jurisdiction', [
      'jurisdictionForm'
    ])
  },
};
</script>

<style lang="less" scoped>
.jurisdiction-footer {
  width: 100%;
  padding: 1.5rem 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    margin-left: 1.5rem;
  }
}
</style>